
export let formLocalStorage= {
    clinic:[{id:0,corporateName:""}],
    email: '',
    Name:'',
    Role:'',
    token:''
}